const styles = theme => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
  },
  select: {
    width: '100%',
    borderRadius: '8px',
    border: '1px solid var(--mcg-gray, #919EAB)',
    background: '#FFF',
    display: 'flex',
    height: '54px',
    alignItems: 'center',
    alignSelf: 'stretch',
    '&::before': {
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: '#FFF',
    },
    '&.Mui-focused': {
      background: '#FFF',
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent !important',
      background: 'transparent !important',
    },
  },
  selectCollection: {
    width: '100%',
    background: '#fff',
  },
  placeholder: {
    paddingLeft: '12px',
  },
  menuItem: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

export default styles
